import { Course, day, defaultUrl, sendPostReq } from "../../Scripts/misc";
import { Modal } from "bootstrap";

interface Props {
    course: Course
    token: string
}

function SignedUpCourseCard({course, token}: Props) {

    const successModalId = "successModal"+course.id

    const signOut = async () => {
        
      let res = await sendPostReq("/api/unsignFromCourse", {token: token, course: course.id})

      switch(res.data) {
          /*case "signedIn":
              waitlistModal?.show()
              break
          case "courseFull":
              fullModal?.show()
              break
          case "rejected":
              rejectedModal?.show()
              break*/
          default:
            (new Modal(document.getElementById(successModalId) as HTMLElement)).show()
            break
      }

  }

    return (<>
        <div className="registered-card" data-club-name={course.name}>
            <img src={defaultUrl + course.image} alt={course.name} />
            <div className="flex-grow-1">
                <h5 className="mb-1">{course.name}</h5>
                <p className="card-info">{day(course.dayOfWeek) + " " + course.startTime + " - " + course.endTime}</p>
            </div>
            <button className="btn btn-secondary" data-toggle="modal"
                data-target={"#infoModal"+course.id}>Více info</button>
            <button className="btn btn-danger" onClick={signOut}>Odhlásit se</button>
        </div>

        {/* Info modal */}
        {/*<div
        className="modal fade"
        id={"infoModal"+course.id}
        tabIndex={-1}
        aria-labelledby="infoModalLabel1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header popup-header">
              <h2 className="modal-title" id="infoModalLabel1">
                {course.name}
              </h2>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body popup-content">
            <div className="popup-info">
                <p><strong>Učitel</strong><br/>{course.teacher}</p>
                <p><strong>Čas</strong><br/>{day(course.dayOfWeek) + " " + course.startTime + " - " + course.endTime}</p>
                <p><strong>Kapacita</strong><br/>{"Kapacita: " + course.totalSignedInStudents + "/" + course.capacity}</p>
                <p><strong>Popis</strong><br/>{course.description}</p>
            </div>
            <div className="popup-image">
                <img src={defaultUrl + course.image} alt={"Obrázek kroužku " + course.name}/>
            </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Zavřít
              </button>
            </div>
          </div>
        </div>
      </div>*/}

        {/* Sign out succesful modal*/}
    {/*<div className="modal fade" id={modalId} tabIndex={-1} aria-labelledby="successLabel">
    <div className="modal-dialog">
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title" id="successLabel">Odhlášení z kroužku</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                Úspěšně jste se odhlásili z kroužku {course.name}
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => {successModal?.hide();window.location.reload()}}>Ok</button>
            </div>
        </div>
    </div>
</div>*/}
</>
    );
}

export default SignedUpCourseCard;